import React from 'react';
import { Card, Image, Text, Group, Badge, Button, ActionIcon, SimpleGrid, createStyles } from '@mantine/core';
import { Link } from 'react-router-dom';

const useStyles = createStyles((theme) => ({
  card: {
    height: 'rem(440px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    backgroundSize: 'cover',
    backgroundPsition: 'center',
    backgroundColor: 'rgb(15,15,15)',
    color: '#FFF',
    fontFamily: `SceneProRg`,
    border: '1px solid rgba(202,204,255,.1)',
  },
  category: {
    color: '#FFF',
    opacity: 0.7,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  title: {
    fontFamily: 'arial',
    fontWeight: 900,
    color: '#FFF',
    lineHeight: 1.2,
    fontSize: 'rem(32px)',
    marginTop: 10,
  },
  section: {
    borderBottom: '1px solid rgba(202,204,255,.1)',
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
  },
}));

const AddOnCard = (props) => {
  const { classes, theme } = useStyles();

  return (
    <>
    <Link to='https://app.urable.com/virtual-shop/nm5qG9H2g5ahH4Xkm9TN' target='_blank' style={{ textDecoration: 'none' }}>
    <Card style={{ borderRadius: '0px' }} p="md" className={classes.card}>
      <Card.Section className={classes.section} mt="md">
        <Group justify="apart">
          <Text fz="lg" mt="xs" fw={500} style={{ fontFamily: `SceneProUltBlk`, fontSize: '26px', fontWeight: 800,  }}>
            {props.priceProp}
          </Text>
        </Group>
        <Text fz="sm" mt="xs" style={{ fontFamily: `SceneProRg`, fontSize: '1.25rem' }}>
          {props.titleProp}
        </Text>
      </Card.Section>
    </Card>
    </Link>
    </>
  )
}

export default AddOnCard;